import { render, staticRenderFns } from "./EspondiloartritesSinglePhase.vue?vue&type=template&id=3206361d&scoped=true&"
import script from "./EspondiloartritesSinglePhase.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesSinglePhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206361d",
  null
  
)

export default component.exports